module.exports = __webpack_public_path__ + "static/media/14_thumbnail.784e2051.png";